<template>
  <fragment>
    <c-generic-section top-divider>
      <div class="container-xs">
        <h2 class="mt-0">Awesome! Your project just got started :)</h2>
        <p class="strong">Thanks for making that payment. I'm eager to get to work on your project.</p>
        <ul>
          <li>You should receive an invoice receipt within moments, and I will also email you personally to confirm the project has started.</li>
          <li>
            Please feel free to
            <router-link to="contact">contact me</router-link>&nbsp;with any questions along the way.
          </li>
        </ul>
      </div>
    </c-generic-section>
  </fragment>
</template>

<script>
// import layout
import CLayout from "@/layouts/LayoutAlternative.vue";
// import section header
// import sections
import CGenericSection from "@/components/sections/GenericSection.vue";
// import CButton from "@/components/elements/Button.vue";
import { loadStripe } from "@stripe/stripe-js";
const stripePromise = loadStripe("pk_test_5brbcIWHvtiDTXoVI0QW4a7X");
export default {
  name: "ProjectPaymentMicro",
  components: {
    CGenericSection,
    // CButton,
  },
  data() {
    return {
      amount: "$1,200 USD",
      items: [],
    };
  },
  created() {
    this.$emit("update:layout", CLayout);
  },
  computed: {
    companyName() {
      if (this.$route && this.$route.query.company)
        return this.$route.query.company;
      return "your business";
    },
  },
  methods: {
    async redirectToCheckout() {
      const stripe = await stripePromise;
      const response = await fetch("/.netlify/functions/stripe-checkout", {
        method: "POST",
      });

      const session = await response.json();

      // When the customer clicks on the button, redirect them to Checkout.
      return await stripe.redirectToCheckout({
        sessionId: session.id,
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.strong {
  font-weight: bold;
}

ul.small {
  margin-top: 1rem;
}

.text-center {
  text-align: center;
}

ul.no-bullets {
  padding-left: 0;
}

ul.no-bullets li {
  margin-left: 0;
  list-style: none;
}
ul.small li {
  margin-top: 0.75rem;
  margin-bottom: 0rem;
  line-height: 1.5;
}
.small {
  font-size: 75%;
}
</style>